module.exports = __webpack_public_path__ + "img/accessory_shoe_07.872b50c9.svg";